import React from "react"
import { ButtonTertiary } from "@nova/component-btn"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ExpandableQRCode } from "features/data-management/workspace/TODO-put-in-package/ExpandableQRCode"
import { ModalNames } from "features/modals/types"
import { useAppDispatch } from "integrations/redux/hooks"
import { usePluginState } from "../../usePluginState"
import { hideGlobalModal } from "runlevel/actions"
import { config } from "@nova/configuration/browser"

const APP_STORE_URL = "https://apps.apple.com/app/id6758868448"
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.mapnova.novalive"

export const LiveVideoMobileModal = () => {
    const { setSelectedPlugin } = usePluginState()
    const dispatch = useAppDispatch()

    return (
        <HighPriorityNovaModalContainer
            title="Back"
            className="w-[34rem]"
            canCloseModal
            closeModal={() => {
                dispatch(hideGlobalModal())
                setSelectedPlugin(undefined)
            }}
            onReturn={() => {
                dispatch(
                    initializeCenterModalForComponentAction(ModalNames.ChooseLiveVideoTypeModal)
                )
                setSelectedPlugin(undefined)
            }}
            HeaderRowComponent={
                <div className="flex items-center ml-2">
                    <h3 className="text-gray-0">Start a Live Stream</h3>
                </div>
            }
            bottomBar={
                <ButtonTertiary
                    title="Close"
                    className="ml-auto"
                    onClick={() => {
                        dispatch(hideGlobalModal())
                        setSelectedPlugin(undefined)
                    }}
                />
            }
        >
            <div className="flex flex-col gap-6 items-center p-8">
                <div className="flex flex-col text-gray-0 items-center">
                    <h5>Enter this URL on your controller to download the .apk file</h5>
                    <h5 className="mt-4 font-bold">{createDownloadUrl()}</h5>
                </div>
                <div className="flex gap-5 items-center w-full px-4">
                    <div className="h-px flex-grow bg-white-200" />
                    <h5 className="text-gray-400">or</h5>
                    <div className="h-px flex-grow bg-white-200" />
                </div>
                <div className="flex flex-col items-center">
                    <h5 className="text-gray-0">Get the Nova Aircast app on your device</h5>
                    <div className="mt-4 flex gap-6 items-center">
                        {/* App Store */}
                        <div className="flex gap-3 items-center">
                            <ExpandableQRCode
                                title="Nova Aircast on the App Store"
                                value={APP_STORE_URL}
                                size={40}
                                fgColor="#FFFFFFB3" // white-500
                                bgColor="transparent"
                            />
                            <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
                                <img
                                    src="/images/mobile-stores/app-store.svg"
                                    alt="Download Nova Aircast on the App Store"
                                    className="h-10 w-auto"
                                    height={40}
                                />
                            </a>
                        </div>

                        {/* Google Play */}
                        <div className="flex gap-3 items-center">
                            <ExpandableQRCode
                                title="Nova Aircast on Google Play"
                                value={GOOGLE_PLAY_URL}
                                size={40}
                                fgColor="#FFFFFFB3" // white-500
                                bgColor="transparent"
                            />
                            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer">
                                <img
                                    src="/images/mobile-stores/google-play.svg"
                                    alt="Download Nova Aircast on Google Play"
                                    className="h-10 w-auto"
                                    height={40}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </HighPriorityNovaModalContainer>
    )
}

const createDownloadUrl = () => {
    const environment = config.get("environmentName")
    if (environment === "production") return "https://cdn.mapnova.com/aircast"
    return `https://cdn.fireai.io/aircast/${environment}`
}
